import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import { StyledChipContainer } from "../FiltersChip/styles";

export const StyledIconChipWrapper = styled(StyledChipContainer)`
    > span {
        gap: 2px;
        height: 24px;
        pointer-events: auto;
        padding-left: 1px;

        span ${SWReactIcons} {
            svg path {
                fill: ${colorsPalettes.midnight[300]};
            }
        }

        &:hover > *:first-child svg path {
            fill: ${colorsPalettes.carbon[300]};
        }

        & > *:first-child {
            flex-shrink: 0;
            border-radius: 12px;
            border: 1px solid ${colorsPalettes.carbon[0]};
            box-sizing: border-box;
            margin: 0;
            background: white;
            width: 20px;
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: center;

            svg {
                width: 20px;
                height: 20px;
            }

            svg path {
                fill: ${colorsPalettes.carbon[200]};
            }

            &:hover svg path {
                fill: ${colorsPalettes.carbon[300]};
            }
        }

        &:has(img) {
            img {
                width: 20px;
                height: 20px;
                border: 2px solid #ffffff;
                box-sizing: border-box;
            }
        }
    }
`;
